import React from 'react';
import PropTypes from 'prop-types';

function Spinner(props) {
  const { loading, className, children, extraText } = props;

  if (!loading) {
    return <div className={className}>{children}</div>;
  }

  return (
    <div data-test="busy-spinner" className={`${className} loading spinner`}>
      {extraText?.length ? <span className="spinner-text">{extraText}</span> : null}
      <div />
    </div>
  );
}

Spinner.propTypes = {
  loading: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node,
  extraText: PropTypes.string,
};

export default Spinner;
